import apiClient from "../../../helpers/apiClient";

export const searchUsers = async (searchTerm, limit = 20) => {
    const queryParams = new URLSearchParams({
        limit: String(limit),
        page: "1",
    });

    if (searchTerm?.trim()) {
        queryParams.append("searchTerm", searchTerm.trim());
    }

    const response = await apiClient.get(`/api/user/list?${queryParams}`);
    if (response?.data?.success) {
        return response.data.data?.result ?? [];
    }

    return [];
};

export const fetchUserById = async (userId) => {
    if (!userId) return null;

    const response = await apiClient.get(`/api/user/${userId}`);
    return response?.data?.data ?? null;
};

export const getUserSearchLabel = (user) => {
    const name = `${user?.firstName ?? ""} ${user?.lastName ?? ""}`.trim();
    const email = user?.email ?? "";
    if (name && email) return `${name} — ${email}`;
    return name || email || user?.mobileNumber || "Customer";
};
